"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";

type Props = {};

export default function Cta({}: Props) {
  return (
    <section className="w-full mx-auto">
      <div className="w-11/12 lg:w-11/12 3xl:w-8/12 mx-auto">
        <div className="relative rounded-2xl md:h-[55vh] h-[45vh] min-h-[360px] overflow-hidden border-2 border-primary2/50 shadow-xl">
          <figure className="absolute inset-0 w-full h-full">
            <Image
              src="/cta.jpeg"
              alt="Travel Beyond Limit"
              fill
              quality={90}
              sizes="(max-width: 768px) 100vw, (max-width: 1536px) 90vw, 1400px"
              className="object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/55 to-black/35"></div>
          </figure>

          <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-4 sm:px-6 md:px-10 text-white max-w-3xl mx-auto">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold uppercase title tracking-wider leading-tight drop-shadow-md">
              Travel Beyond Limit
            </h2>
            <p className="mt-3 md:mt-4 text-xs sm:text-sm md:text-base lg:text-lg font-medium text-zinc-200 leading-relaxed max-w-2xl">
              Get PDF before flying Nepal. Experience the world-class tour package at the best rate.
            </p>

            <div className="mt-6 md:mt-8">
              <Link href="/partner">
                <button className="px-5 sm:px-7 py-3 rounded-md bg-primary2 hover:bg-orange-700 active:scale-95 transition-all duration-200 font-bold text-xs sm:text-sm md:text-base text-white shadow-lg hover:shadow-orange-500/25 cursor-pointer">
                  Become Partner with us
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
